import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { getValueInCurrency } from "../../../common/utils";
import { getCurrencyFromSetup } from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export default function EventMoneyData({ data, dataEditionFunction }) {
  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: 4,
        padding: 2,
        background: "#f5f6f8",
      }}
    >
      <Grid container spacing={2}>
        {/* INGRESOS */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  background: "#2e7d32",
                  p: 1,
                  borderRadius: 2,
                }}
              >
                {localize.incomes}
              </Typography>

              <Box mt={2}>
                {[
                  {
                    label: localize.service_value,
                    value: getValueInCurrency(
                      getCurrencyFromSetup(),
                      data?.serviceValue ?? 0,
                      true,
                    ),
                  },
                  {
                    label: localize.spare_parts_value,
                    value: getValueInCurrency(
                      getCurrencyFromSetup(),
                      data?.sparePartsValue ?? 0,
                      true,
                    ),
                  },
                  {
                    label: localize.additional_costs,
                    value: getValueInCurrency(
                      getCurrencyFromSetup(),
                      data?.additionalCosts ?? 0,
                      true,
                    ),
                  },
                ].map((item, index) => (
                  <Box key={index} mb={1}>
                    <Typography sx={{ color: "#2e7d32", fontWeight: 600 }}>
                      {`+ ${item.value}`}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {item.label}
                    </Typography>
                    <Divider sx={{ mt: 1 }} />
                  </Box>
                ))}
              </Box>

              <Box mt={2}>
                <Divider
                  sx={{ borderBottomWidth: 2, borderColor: "#2e7d32" }}
                />
                <Typography
                  variant="h6"
                  sx={{ color: "#2e7d32", fontWeight: "bold", mt: 1 }}
                >
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    data?.totalValue ?? 0,
                    true,
                  )}
                </Typography>
                <Typography variant="caption">{localize.total_value}</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* EGRESOS */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 3, height: "100%" }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  background: "#d32f2f",
                  p: 1,
                  borderRadius: 2,
                }}
              >
                {localize.outcomes}
              </Typography>

              <Box mt={2}>
                {[
                  {
                    label: localize.spare_parts_real_value,
                    value: getValueInCurrency(
                      getCurrencyFromSetup(),
                      data?.sparePartsRealValue ?? 0,
                      true,
                    ),
                  },
                  {
                    label: localize.payment_to_technician,
                    value: getValueInCurrency(
                      getCurrencyFromSetup(),
                      data?.paymentToTechnicians ?? 0,
                      true,
                    ),
                  },
                ].map((item, index) => (
                  <Box key={index} mb={1}>
                    <Typography sx={{ color: "#d32f2f", fontWeight: 600 }}>
                      {`- ${item.value}`}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {item.label}
                    </Typography>
                    <Divider sx={{ mt: 1 }} />
                  </Box>
                ))}
              </Box>

              <Box mt={2}>
                <Divider
                  sx={{ borderBottomWidth: 2, borderColor: "#d32f2f" }}
                />
                <Typography
                  variant="h6"
                  sx={{ color: "#d32f2f", fontWeight: "bold", mt: 1 }}
                >
                  {`- ${getValueInCurrency(
                    getCurrencyFromSetup(),
                    (data?.sparePartsRealValue ?? 0) +
                      (data?.paymentToTechnicians > 0
                        ? data?.paymentToTechnicians
                        : 0),
                    true,
                  )}`}
                </Typography>
                <Typography variant="caption">Valor Total</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* TOTAL */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              borderRadius: 3,
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {dataEditionFunction && (
              <IconButton
                onClick={dataEditionFunction}
                sx={{ position: "absolute", top: 8, right: 8 }}
                size="small"
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            <CardContent sx={{ textAlign: "center" }}>
              <Typography variant="h6" color="text.secondary">
                {localize.real_income}
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2, color: (data?.realIncome ?? 0) > 0 ? "green" : (data?.realIncome ?? 0) < 0 ? "red" : "#383636" }}>
                {getValueInCurrency(
                  getCurrencyFromSetup(),
                  data?.realIncome ?? 0,
                  true,
                )}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
}
